import Affix from './affix';
import Avatar from './avatar';
import Article from './article';
import Carousel from './carousel';
import Crud from './crud';
import Card from './card';
import Color from './color';
import Comment from './comment';
import Form from './form';
import Checkbox from './checkbox';
import Date from './date';
import Detail from './detail';
import Divider from './divider';
import Empty from './empty';
import Progress from './progress';
import Time from './time';
import Input from './input';
import Radio from './radio';
import Select from './select';
import Cascader from './cascader';
import InputNumber from './input-number';
import Switchs from './switch';
import Rate from './rate';
import Upload from './upload';
import Silder from './silder';
import Img from './img';
import Group from './group';
import Tree from './tree';
import TableTree from './table-tree';
import Search from './search';
import Skeleton from './skeleton';
import Tabs from './tabs';
import Dynamic from './dynamic';
import Queue from './queue';
import IconSelect from './icon-select';
import Timeline from './timeline';
import Drawer from './drawer';
import BackTop from './back-top';
import textEllipsis from './text-ellipsis';
import Network from './network';
import Singular from './singular';
import Dimension from './dimension';
import Page from './page';

export default [
  Affix,
  Avatar,
  Article,
  Carousel,
  Crud,
  Color,
  Card,
  Comment,
  Form,
  Checkbox,
  Date,
  Divider,
  Empty,
  Progress,
  Time,
  Input,
  Radio,
  Select,
  Cascader,
  InputNumber,
  Switchs,
  Rate,
  Upload,
  Silder,
  Img,
  Detail,
  Group,
  Tree,
  TableTree,
  Search,
  Tabs,
  Queue,
  Dynamic,
  IconSelect,
  Drawer,
  BackTop,
  Timeline,
  Timeline.Item,
  textEllipsis,
  Skeleton,
  Network,
  Singular,
  Dimension,
  Page

];
